import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
}
export function Input({
  className = '',
  icon,
  ...props
}: InputProps) {
  return <div className="relative flex items-center w-full" data-id="element-117">
      {icon && <div className="absolute left-3 text-muted-foreground" data-id="element-118">{icon}</div>}
      <input className={`flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${icon ? 'pl-9' : ''} ${className}`} {...props} data-id="element-119" />

    </div>;
}